var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('AboutMenu',{attrs:{"menu":[
    { name: '股票信息', url: '/relationship/stock' },
    { name: '公司公告', url: '/relationship/note' },
    { name: '社会责任', url: '/responsibility' } ]}})}
var staticRenderFns = []

export { render, staticRenderFns }